import React from "react";
import { Stack } from "@mui/material";
import { PieChart } from "./PieChart";
import { IPortfolioConstructionPieChart } from "store/types";

interface PieChartsBoxProps {
  loading: boolean;
  data?: IPortfolioConstructionPieChart[];
}

export const PieChartsBox: React.FC<PieChartsBoxProps> = ({ loading, data }) => {
  return (
    <Stack direction="row" gap="20px" justifyContent="space-between" mb="5px" width="100%">
      {data?.map((chart) => <PieChart key={chart.title} data={chart} loading={loading} />)}
    </Stack>
  );
};
